import React from 'react'
import { Button } from '@mui/material'

// סרגל ניווט לפי העיצוב: [מונה] [לדף הקודם] [לדף הבא] — כפתור הפעולה עבר לתחתית העמוד
// חיצים מלאים של Font Awesome (כמו בפיגמה, Icon/Small 14px) — לא שברוני MUI
const PresentationNavBar = ({ navigation, slideCount }) => {
    const { currentSlide, next, prev, isFirst, isLast } = navigation

    return (
        <div className='presentation-nav'>
            <div className='nav-counter'>{`${currentSlide + 1}/${slideCount}`}</div>

            <Button className='nav-btn' onClick={prev}
                // disabled={isFirst}
                type='button'>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <i className='fa-regular fa-arrow-right' />
                    <span>{isFirst ? 'לדף האחרון' : 'לדף הקודם'}</span>
                </span>
            </Button>

            <Button className='nav-btn' onClick={next}
                // disabled={isLast}
                type='button'>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span>{isLast ? 'לדף הראשון' : 'לדף הבא'}</span>
                    <i className='fa-regular fa-arrow-left' />
                </span>
            </Button>
        </div>
    )
}

export default PresentationNavBar
